import { render, staticRenderFns } from "./NewsListHotTwo.vue?vue&type=template&id=60155245"
import script from "./NewsListHotTwo.vue?vue&type=script&lang=js"
export * from "./NewsListHotTwo.vue?vue&type=script&lang=js"
import style0 from "./NewsListHotTwo.vue?vue&type=style&index=0&id=60155245&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports